/**
 * Suggestion Callout Wrapper
 * @param {{children:import('react').ReactNode}} param0
 * @returns
 */
export default function SuggestionCallout({ children }) {
  return (
    <div className="border rounded-lg border-segments-accent-color-orange bg-segments-accent-color-orange">
      <div className="h-4 rounded-t-lg bg-segments-accent-color-orange" />
      <div className="bg-white rounded-lg">{children}</div>
    </div>
  );
}

// ** Paginated Suggestion Callout - To be implemented

// export default function PaginatedSuggestions({ suggestions }) {
//   const totalPages = Object.keys(suggestions || {}).length;

//   const [pageIndex, setPageIndex] = useState(0);
//   if (!!!suggestions) return null;

//   return (
//     <SuggestionCallout>
//       <div className="flex">
//         <div className="flex-1 px-6 py-4 ">
//           <p className="text-black text-segments-13px text-opacity-30">
//             {pageIndex + 1}/{totalPages}
//           </p>
//           <p className="mt-4">{Object.values(suggestions)[pageIndex]}</p>
//         </div>
//         {/* <div className="flex items-center justify-center border-l w-28">
//           {pageIndex === 0 && (
//             <NextButton setPageIndex={setPageIndex} pageIndex={pageIndex} />
//           )}
//           {pageIndex === totalPages - 1 && (
//             <PreviousButton setPageIndex={setPageIndex} pageIndex={pageIndex} />
//           )}

//           {pageIndex !== 0 && pageIndex !== totalPages - 1 && (
//             <PreviousAndNextButton
//               setPageIndex={setPageIndex}
//               pageIndex={pageIndex}
//             />
//           )}
//         </div> */}
//       </div>
//     </SuggestionCallout>
//   );
// }

// /**
//  *
//  * @param {{setPageIndex:Function, pageIndex:number}} param0
//  * @returns
//  */
// function NextButton({ setPageIndex, pageIndex }) {
//   return (
//     <button
//       onClick={() => setPageIndex(pageIndex + 1)}
//       className="flex items-center justify-center w-full h-full space-x-2 focus:outline-none"
//     >
//       <p>Next</p>
//       <ChevronLeftIcon className="w-4 h-4 transform rotate-180" />
//     </button>
//   );
// }

// /**
//  *
//  * @param {{setPageIndex:Function, pageIndex:number}} param0
//  * @returns
//  */
// function PreviousButton({ setPageIndex, pageIndex }) {
//   return (
//     <button
//       onClick={() => setPageIndex(pageIndex - 1)}
//       className="flex items-center justify-center w-full h-full space-x-2 focus:outline-none"
//     >
//       <ChevronLeftIcon className="w-4 h-4" />
//       <p>Previous</p>
//     </button>
//   );
// }

// /**
//  *
//  * @param {{setPageIndex:Function, pageIndex:number}} param0
//  * @returns
//  */
// function PreviousAndNextButton({ setPageIndex, pageIndex }) {
//   return (
//     <div className="flex flex-col justify-between flex-1 h-full divide-y text-segments-13px">
//       <button
//         onClick={() => setPageIndex(pageIndex - 1)}
//         className="flex items-center justify-start flex-1 px-4 space-x-2 focus:outline-none"
//       >
//         <ChevronLeftIcon className="w-4 h-4" />
//         <p>Previous</p>
//       </button>

//       <button
//         onClick={() => setPageIndex(pageIndex + 1)}
//         className="flex items-center flex-1 px-4 space-x-2 focus:outline-none justify-items-start"
//       >
//         <ChevronLeftIcon className="w-4 h-4 transform rotate-180" />
//         <p>Next</p>
//       </button>
//     </div>
//   );
// }
